import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import { OffersOfApplication } from '../../../../type/result_type';
import { OfferType, PopupEventType } from '../../../../type/offer_type';
import {DialogService} from "../../../../service/dialog.service";
import {DialogRef} from "@angular/cdk/dialog";
import {BreakpointService} from "../../../../service/breakpoint.service";

@Component({
  selector: 'app-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.scss'],
})
export class CouponComponent implements OnInit {
  @Input() popup!: OfferType['popup'];
  @Input() sliderWrapper!: boolean;
  @Input() windowCouponLabel!: string;
  @Input() windowCouponAmount!: string;
  @Input() cardId!: OffersOfApplication['id'];

  @ViewChild('dialogContent') dialogContent!: TemplateRef<any>;
  @ViewChild('dialogActions') dialogActions!: TemplateRef<any>;

  @Output() couponPopupChange = new EventEmitter<boolean>();

  private dialogRef: DialogRef<string> = null;
  private isTouchEvent: boolean = false;
  private setTimeoutPopup: NodeJS.Timeout;

  constructor(
    private dialogService: DialogService,
    private breakpointService: BreakpointService,
  ) {}

  get windowSize() {
    return this.breakpointService.windowSize;
  }

  ngOnInit(): void {}

  openDialog() {
    this.dialogRef = this.dialogService.open('Kreditdetails', this.dialogContent, this.dialogActions);
    this.dialogRef.closed.subscribe(result => {
      console.log('Dialog closed with result:', result);
      this.dialogRef = null;
    });
  }

  openPopup(): void {
    if (this.windowSize === 'mobile') {
      this.openDialog();
    } else {
      this.couponPopupChange.emit(true);
      if (this.popup?.['coupon'] && this.popup['coupon'] === this.cardId) {
        clearTimeout(this.setTimeoutPopup);
      }
    }
  }

  closePopup(timeout): void {
    this.setTimeoutPopup = setTimeout(
      () => {
        this.couponPopupChange.emit(false);
      },
      this.popup?.['coupon'] && this.popup['coupon'] === this.cardId && timeout
        ? timeout
        : 0,
    );
  }

  mouseEvent(value: boolean): void {
    if (!this.isTouchEvent) {
      value ? this.openPopup() : this.closePopup(600);
    }
  }

  touchEvent(): void {
    this.isTouchEvent = true;
    this.openPopup();
  }

  popupEvent(value: PopupEventType): void {
    value.openPopup
      ? this.openPopup()
      : this.closePopup(value.timeout ? Number(value.timeout) : 600);
  }
}
